import React from 'react';
import PropTypes from 'prop-types';
import ListCardGrid from '../../ListCardGrid';
import { getTranslation } from '../../../providers/TranslationProvider';

import InfoIcon from '../../../svg/icons/ic_info-outline_red_35x35.svg';
import Button from '../../Button';
import Icon from '../../Icon';

import './MultipleListsView.scss';

function MultipleListsView({
  isLoading, isError, lists, onListClick, onAddListClick,
}) {
  const handleRefreshClick = () => {
    window.location.reload();
  };

  return (
    <div className="MultipleListsView">
      <h2 className="MultipleListsView__title">
        {getTranslation({
          translationKey: 'lists.title',
          fallback: 'Lists',
        })}
      </h2>
      {(isError) ? (
        <div className="MultipleListsView__error">
          <div className="MultipleListsView__error-icon">
            <Icon name="info" component={InfoIcon} width="35px" height="35px" />
          </div>
          <h3 className="MultipleListsView__error-title">
            {getTranslation({
              translationKey: 'errors.lists.no_data_title',
              fallback: 'Oops! Unable to load page.',
            })}
          </h3>
          <p className="MultipleListsView__error-body">
            {getTranslation({
              translationKey: 'errors.lists.no_data_body',
              fallback: 'Please try again.',
            })}
          </p>
          <Button
            sm
            className="MultipleListsView__error-cta"
            onClick={handleRefreshClick}
          >
            {getTranslation({
              translationKey: 'errors.lists.no_data_cta',
              fallback: 'Try Again',
            })}
          </Button>
        </div>
      ) : (
        <ListCardGrid
          isLoading={isLoading}
          lists={lists}
          onListClick={onListClick}
          onAddListClick={onAddListClick}
        />
      )}
    </div>
  );
}

MultipleListsView.propTypes = {
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  lists: PropTypes.arrayOf(PropTypes.shape({})),
  onListClick: PropTypes.func,
  onAddListClick: PropTypes.func,
};

MultipleListsView.defaultProps = {
  isLoading: true,
  isError: false,
  lists: [],
  onListClick: /* istanbul ignore next */ () => {},
  onAddListClick: /* istanbul ignore next */ () => {},
};

export default MultipleListsView;
